import { render } from "./ChatsItem.vue?vue&type=template&id=35338b3b&scoped=true"
import script from "./ChatsItem.vue?vue&type=script&lang=js"
export * from "./ChatsItem.vue?vue&type=script&lang=js"

import "./ChatsItem.vue?vue&type=style&index=0&id=35338b3b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35338b3b"]])

export default __exports__